import { Link } from "react-router-dom";
import { Compass } from "Components/ui/icons";

import { Button, EmptyState } from "Components/ui";

const NotFound = () => (
  <div className="flex min-h-[70vh] w-full items-center justify-center px-6">
    <EmptyState
      icon={<Compass />}
      title="Page not found"
      description="The address may be mistyped, or the page has moved."
      action={
        <Button asChild variant="secondary">
          <Link to="/dashboard">Go to dashboard</Link>
        </Button>
      }
    />
  </div>
);

export default NotFound;
